module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-chip', {
    attrs: {
      "label": "",
      "close": _vm.canExclude,
      "color": _vm.background,
      "text-color": _vm.foreground
    },
    on: {
      "input": _vm.exclude
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5924e6d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarEventChip.vue
// module id = 413
// module chunks = 1